import React from 'react';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import Header from './Header';

interface SuccessMessageProps {
    title?: string;
    subtitle?: string;
    extraContent?: React.ReactNode;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
    title = 'תודה רבה!',
    subtitle = 'התשובות נקלטו בהצלחה.',
    extraContent
}) => {
    return (
        <div className="min-h-screen bg-white flex flex-col">
            <Header />

            <main className="flex-grow flex flex-col items-center px-6 pt-12 pb-20 relative z-20">
                <div className="w-full max-w-xl bg-white border border-brand-gold/20 rounded-3xl p-8 sm:p-12 shadow-[0_20px_40px_rgba(19,52,55,0.05)] text-center animate-in fade-in zoom-in duration-500">
                    <div className="success-checkmark mb-6">
                        <CheckCircle2 className="w-10 h-10" />
                    </div>

                    <h2 className="text-2xl font-bold text-brand-dark mb-2 font-serif">{title}</h2>
                    <p className="text-brand-dark/70 text-lg mb-8">{subtitle}</p>

                    {extraContent}

                    <a
                        href="https://karenavnam.com/"
                        className="w-full inline-flex items-center justify-center gap-3 px-8 py-4 bg-brand-dark text-white font-bold rounded-2xl transition-all hover:bg-brand-dark/90 hover:shadow-lg transform hover:-translate-y-1 active:scale-95"
                    >
                        לבקר באתר של קארן אבנם
                        <ArrowLeft className="w-5 h-5" />
                    </a>
                </div>
            </main>
        </div>
    );
};

export default SuccessMessage;
